/* tslint:disable */
/* eslint-disable */
/**
 * grpc/client_data/client-data.service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { ClientDataServiceAddClientFileBody } from '../models'
// @ts-ignore
import { ClientDataServiceAddClientTagBody } from '../models'
// @ts-ignore
import { ClientDataServiceAddManagerNoteBody } from '../models'
// @ts-ignore
import { ClientDataServiceLogClientFileDownloadBody } from '../models'
// @ts-ignore
import { ClientDataServiceResolveClientDuplicateBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateArchiveReasonBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateClientBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateClientFileBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateCountryBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateLeadSourceBody } from '../models'
// @ts-ignore
import { ClientDataServiceUpdateManagerNoteBody } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1AddClientFileResponse } from '../models'
// @ts-ignore
import { V1BulkUpdateClientsRequest } from '../models'
// @ts-ignore
import { V1BulkUpdateClientsResponse } from '../models'
// @ts-ignore
import { V1Client } from '../models'
// @ts-ignore
import { V1ClientTagsResponse } from '../models'
// @ts-ignore
import { V1CreateArchiveReasonRequest } from '../models'
// @ts-ignore
import { V1CreateArchiveReasonResponse } from '../models'
// @ts-ignore
import { V1CreateCountryRequest } from '../models'
// @ts-ignore
import { V1CreateCountryResponse } from '../models'
// @ts-ignore
import { V1CreateLeadSourceRequest } from '../models'
// @ts-ignore
import { V1CreateLeadSourceResponse } from '../models'
// @ts-ignore
import { V1DashboardMetricsResponse } from '../models'
// @ts-ignore
import { V1GetArchiveReasonsResponse } from '../models'
// @ts-ignore
import { V1GetClientFieldDefinitionsResponse } from '../models'
// @ts-ignore
import { V1GetCountriesResponse } from '../models'
// @ts-ignore
import { V1GetLeadSourcesResponse } from '../models'
// @ts-ignore
import { V1GetManagersResponse } from '../models'
// @ts-ignore
import { V1GetTagsResponse } from '../models'
// @ts-ignore
import { V1ListArchiveReasonsResponse } from '../models'
// @ts-ignore
import { V1ListClientChangeLogsResponse } from '../models'
// @ts-ignore
import { V1ListClientDataResponse } from '../models'
// @ts-ignore
import { V1ListClientFilesResponse } from '../models'
// @ts-ignore
import { V1ListCountriesResponse } from '../models'
// @ts-ignore
import { V1ListLeadSourceBreakdownResponse } from '../models'
// @ts-ignore
import { V1ListLeadSourcesResponse } from '../models'
// @ts-ignore
import { V1ManagerNote } from '../models'
// @ts-ignore
import { V1ResolveClientDuplicateResponse } from '../models'
// @ts-ignore
import { V1ResolveUsersRequest } from '../models'
// @ts-ignore
import { V1ResolveUsersResponse } from '../models'
// @ts-ignore
import { V1SearchCitiesResponse } from '../models'
// @ts-ignore
import { V1TransferManagerClientsRequest } from '../models'
// @ts-ignore
import { V1TransferManagerClientsResponse } from '../models'
// @ts-ignore
import { V1UpdateArchiveReasonResponse } from '../models'
// @ts-ignore
import { V1UpdateClientFileResponse } from '../models'
// @ts-ignore
import { V1UpdateCountryResponse } from '../models'
// @ts-ignore
import { V1UpdateLeadSourceResponse } from '../models'
/**
 * ClientDataServiceApi - axios parameter creator
 * @export
 */
export const ClientDataServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Attaches an already uploaded file to a client.
     * @param {string} clientId
     * @param {ClientDataServiceAddClientFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceAddClientFile: async (
      clientId: string,
      body: ClientDataServiceAddClientFileBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceAddClientFile', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceAddClientFile', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/files`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Puts a label on a client and returns the labels it has afterwards.
     * @param {string} clientId
     * @param {ClientDataServiceAddClientTagBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceAddClientTag: async (
      clientId: string,
      body: ClientDataServiceAddClientTagBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceAddClientTag', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceAddClientTag', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/tags`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds a note to a client.
     * @param {string} clientId
     * @param {ClientDataServiceAddManagerNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceAddManagerNote: async (
      clientId: string,
      body: ClientDataServiceAddManagerNoteBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceAddManagerNote', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceAddManagerNote', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/notes`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes the responsible manager of many clients at once.
     * @param {V1BulkUpdateClientsRequest} body Which clients to change, and how.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceBulkUpdateClients: async (
      body: V1BulkUpdateClientsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceBulkUpdateClients', 'body', body)
      const localVarPath = `/api/v1/clients/bulk-update`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds an archive reason.
     * @param {V1CreateArchiveReasonRequest} body A new archive reason. Shaped exactly like a lead source, because the sales report groups closed leads by the key of the reason they were closed with.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateArchiveReason: async (
      body: V1CreateArchiveReasonRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceCreateArchiveReason', 'body', body)
      const localVarPath = `/api/v1/admin/references/archive-reasons`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Creates a full client card from the CRM.
     * @param {V1Client} client The client card. Naming a responsible manager assigns the client straight away; leaving it empty hands the client to the automatic distribution.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateClient: async (
      client: V1Client,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'client' is not null or undefined
      assertParamExists('clientDataServiceCreateClient', 'client', client)
      const localVarPath = `/api/v1/clients`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        client,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * The rules are looser than for a client created by a manager, because a web form asks for very little: a lead with only a phone number still has to be recorded.
     * @summary Creates a client from a form filled in on the public website.
     * @param {V1Client} client The client card. Naming a responsible manager assigns the client straight away; leaving it empty hands the client to the automatic distribution.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateClientFromFormData: async (
      client: V1Client,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'client' is not null or undefined
      assertParamExists('clientDataServiceCreateClientFromFormData', 'client', client)
      const localVarPath = `/api/v1/clients/form-data`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        client,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds a country.
     * @param {V1CreateCountryRequest} body A new country.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateCountry: async (
      body: V1CreateCountryRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceCreateCountry', 'body', body)
      const localVarPath = `/api/v1/admin/references/countries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds a lead source.
     * @param {V1CreateLeadSourceRequest} body A new lead source. Names are required in all three languages, because the source shows up on client cards in every locale.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateLeadSource: async (
      body: V1CreateLeadSourceRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceCreateLeadSource', 'body', body)
      const localVarPath = `/api/v1/admin/references/lead-sources`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Removes an archive reason. Clients already archived with it keep it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteArchiveReason: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceDeleteArchiveReason', 'id', id)
      const localVarPath = `/api/v1/admin/references/archive-reasons/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Removes one way of contacting a client and returns the client afterwards.
     * @param {string} clientId
     * @param {string} contactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteClientContact: async (
      clientId: string,
      contactId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceDeleteClientContact', 'clientId', clientId)
      // verify required parameter 'contactId' is not null or undefined
      assertParamExists('clientDataServiceDeleteClientContact', 'contactId', contactId)
      const localVarPath = `/api/v1/clients/{clientId}/contacts/{contactId}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'contactId'}}`, encodeURIComponent(String(contactId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Detaches a file from a client.
     * @param {string} clientId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteClientFile: async (
      clientId: string,
      fileId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceDeleteClientFile', 'clientId', clientId)
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists('clientDataServiceDeleteClientFile', 'fileId', fileId)
      const localVarPath = `/api/v1/clients/{clientId}/files/{fileId}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'fileId'}}`, encodeURIComponent(String(fileId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Removes a country.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteCountry: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceDeleteCountry', 'id', id)
      const localVarPath = `/api/v1/admin/references/countries/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Removes a lead source. Clients already attributed to it keep it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteLeadSource: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceDeleteLeadSource', 'id', id)
      const localVarPath = `/api/v1/admin/references/lead-sources/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a note.
     * @param {string} clientId
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteManagerNote: async (
      clientId: string,
      noteId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceDeleteManagerNote', 'clientId', clientId)
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists('clientDataServiceDeleteManagerNote', 'noteId', noteId)
      const localVarPath = `/api/v1/clients/{clientId}/notes/{noteId}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'noteId'}}`, encodeURIComponent(String(noteId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the reasons a client can be archived for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetArchiveReasons: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/archive-reasons`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one client card in full.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetClient: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceGetClient', 'id', id)
      const localVarPath = `/api/v1/clients/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * The list is fixed in code rather than kept in a table: what counts as \"filled in\" differs from field to field, and that rule lives next to the card it describes.
     * @summary Lists the client card fields a funnel stage can require to be filled in before a deal moves onto it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetClientFieldDefinitions: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/client-fields`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the countries a client can belong to, with their dialling codes and phone number lengths.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetCountriesReferences: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/countries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the client counters of the caller\'s dashboard: how many clients there are and how that changed.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Defaults to \&quot;month\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetDashboardMetrics: async (
      period?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/dashboard-metrics`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (period !== undefined) {
        localVarQueryParameter['period'] = period
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the lead sources a client can be attributed to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetLeadSources: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/lead-sources`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: restricted to administrators and the head of sales.
     * @summary Lists the managers clients can be assigned to.
     * @param {string} [role] Role to list: \&quot;manager\&quot; by default, or \&quot;support_manager\&quot; for the managers who can be added to a deal as helpers. The latter is available to an ordinary manager too, because the responsible manager picks the helper themselves.
     * @param {boolean} [activeOnly] True returns only people still working here, which is what a picker for \&quot;who should take these clients\&quot; needs. False, the default, also returns people who have left: their names are still needed by filters and by historical records.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetManagers: async (
      role?: string,
      activeOnly?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/managers`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (role !== undefined) {
        localVarQueryParameter['role'] = role
      }

      if (activeOnly !== undefined) {
        localVarQueryParameter['activeOnly'] = activeOnly
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the labels a client can carry.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetTags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/tags`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists archive reasons for administration, including inactive ones.
     * @param {boolean} [includeInactive] Include reasons that are no longer offered. Useful when rendering clients archived with one of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListArchiveReasonsAdmin: async (
      includeInactive?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/admin/references/archive-reasons`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (includeInactive !== undefined) {
        localVarQueryParameter['includeInactive'] = includeInactive
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the history of a client: who changed what and when.
     * @param {string} clientId
     * @param {ClientDataServiceListClientChangeLogsActionTypeEnum} [actionType] Return only entries of this kind. Left out, every kind is returned.   - CLIENT_CHANGE_ACTION_TYPE_CREATED: The client was created.  - CLIENT_CHANGE_ACTION_TYPE_UPDATED: Fields of the client were edited.  - CLIENT_CHANGE_ACTION_TYPE_STAGE_CHANGED: The stage changed.  - CLIENT_CHANGE_ACTION_TYPE_STATUS_CHANGED: The status changed.  - CLIENT_CHANGE_ACTION_TYPE_TASK_CREATED: A task was created.  - CLIENT_CHANGE_ACTION_TYPE_TASK_UPDATED: A task was edited.  - CLIENT_CHANGE_ACTION_TYPE_TASK_COMPLETED: A task was completed.  - CLIENT_CHANGE_ACTION_TYPE_TASK_DELETED: A task was deleted.  - CLIENT_CHANGE_ACTION_TYPE_NOTE_ADDED: A note was added.  - CLIENT_CHANGE_ACTION_TYPE_NOTE_UPDATED: A note was edited.  - CLIENT_CHANGE_ACTION_TYPE_NOTE_DELETED: A note was deleted.  - CLIENT_CHANGE_ACTION_TYPE_MANAGER_ASSIGNED: A manager was made responsible for the client.  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_ADDED: A way of contacting the client was added.  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_REMOVED: A way of contacting the client was removed.  - CLIENT_CHANGE_ACTION_TYPE_DELETED: The client was deleted.  - CLIENT_CHANGE_ACTION_TYPE_FILE_UPLOADED: A file was uploaded.  - CLIENT_CHANGE_ACTION_TYPE_FILE_DOWNLOADED: A file was downloaded.
     * @param {number} [limit] Most entries to return. Fifty by default.
     * @param {number} [offset] How many entries to skip.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientChangeLogs: async (
      clientId: string,
      actionType?: ClientDataServiceListClientChangeLogsActionTypeEnum,
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceListClientChangeLogs', 'clientId', clientId)
      const localVarPath = `/api/v1/clients/{clientId}/change-logs`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (actionType !== undefined) {
        localVarQueryParameter['actionType'] = actionType
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists clients with filters, sorting and paging.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [responsibleManagerId]
     * @param {string} [leadSource]
     * @param {Array<string>} [statuses] Statuses to include.
     * @param {Array<string>} [leadSources] Lead sources to include.
     * @param {string} [dateFrom] Only clients created at or after this moment.
     * @param {string} [dateTo] Only clients created at or before this moment.
     * @param {string} [searchQuery] Full-text search over name, email address and phone number.
     * @param {string} [language] Language the client prefers to be addressed in.
     * @param {boolean} [hasDeal] True returns only clients that have a deal, false only those that have none. Left out, the filter is not applied.
     * @param {boolean} [isArchived] True returns only archived clients. False or left out returns only active ones.
     * @param {boolean} [hasResponsibleManager] True returns only clients that have a responsible manager, false only those without one. Left out, the filter is not applied. It backs the \&quot;my clients\&quot; and \&quot;unassigned\&quot; presets, and is ignored for callers who can see only their own clients anyway.
     * @param {string} [agentId] Agent who brought the client in.
     * @param {boolean} [hasAgent] True returns only clients brought in by an agent, false only those that came in directly. Left out, the filter is not applied.
     * @param {string} [agentDuplicateStatus] Whether an agent lead turned out to be someone already known: not_checked, unique, duplicate_pending, duplicate_confirmed or rejected. Whatever the filter says, the caller still only sees the clients their role allows.
     * @param {Array<string>} [tagKeys] Labels the client must carry. Several keys match a client carrying any one of them.
     * @param {Array<string>} [archiveReasonIds] Archive reasons to include. Several match a client archived for any one of them. Only meaningful together with the archived filter.
     * @param {Array<string>} [cityIds] Cities to include. A client counts as matching when its city comes from the dictionary; a manually typed city never matches.
     * @param {string} [countryId] Country of the client.
     * @param {Array<string>} [sourceKeys] Where the leads came from, at any depth of the source tree: a lead source alone, a site within it, or a campaign on that site. A client matches if it matches any of the keys.  A key is \&quot;&lt;lead_source_id&gt;\&quot;, \&quot;&lt;lead_source_id&gt;|&lt;landing_slug&gt;\&quot;, \&quot;&lt;lead_source_id&gt;|&lt;landing_slug&gt;|campaign:&lt;utm_campaign&gt;\&quot; or \&quot;&lt;lead_source_id&gt;|&lt;landing_slug&gt;|source:&lt;utm_source&gt;\&quot;; the site may be empty at the campaign level. Keys come from ListLeadSourceBreakdown.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientData: async (
      paginationPage?: string,
      paginationPerPage?: string,
      responsibleManagerId?: string,
      leadSource?: string,
      statuses?: Array<string>,
      leadSources?: Array<string>,
      dateFrom?: string,
      dateTo?: string,
      searchQuery?: string,
      language?: string,
      hasDeal?: boolean,
      isArchived?: boolean,
      hasResponsibleManager?: boolean,
      agentId?: string,
      hasAgent?: boolean,
      agentDuplicateStatus?: string,
      tagKeys?: Array<string>,
      archiveReasonIds?: Array<string>,
      cityIds?: Array<string>,
      countryId?: string,
      sourceKeys?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/clients`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (responsibleManagerId !== undefined) {
        localVarQueryParameter['responsibleManagerId'] = responsibleManagerId
      }

      if (leadSource !== undefined) {
        localVarQueryParameter['leadSource'] = leadSource
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses
      }

      if (leadSources) {
        localVarQueryParameter['leadSources'] = leadSources
      }

      if (dateFrom !== undefined) {
        localVarQueryParameter['dateFrom'] =
          (dateFrom as any) instanceof Date ? (dateFrom as any).toISOString() : dateFrom
      }

      if (dateTo !== undefined) {
        localVarQueryParameter['dateTo'] =
          (dateTo as any) instanceof Date ? (dateTo as any).toISOString() : dateTo
      }

      if (searchQuery !== undefined) {
        localVarQueryParameter['searchQuery'] = searchQuery
      }

      if (language !== undefined) {
        localVarQueryParameter['language'] = language
      }

      if (hasDeal !== undefined) {
        localVarQueryParameter['hasDeal'] = hasDeal
      }

      if (isArchived !== undefined) {
        localVarQueryParameter['isArchived'] = isArchived
      }

      if (hasResponsibleManager !== undefined) {
        localVarQueryParameter['hasResponsibleManager'] = hasResponsibleManager
      }

      if (agentId !== undefined) {
        localVarQueryParameter['agentId'] = agentId
      }

      if (hasAgent !== undefined) {
        localVarQueryParameter['hasAgent'] = hasAgent
      }

      if (agentDuplicateStatus !== undefined) {
        localVarQueryParameter['agentDuplicateStatus'] = agentDuplicateStatus
      }

      if (tagKeys) {
        localVarQueryParameter['tagKeys'] = tagKeys
      }

      if (archiveReasonIds) {
        localVarQueryParameter['archiveReasonIds'] = archiveReasonIds
      }

      if (cityIds) {
        localVarQueryParameter['cityIds'] = cityIds
      }

      if (countryId !== undefined) {
        localVarQueryParameter['countryId'] = countryId
      }

      if (sourceKeys) {
        localVarQueryParameter['sourceKeys'] = sourceKeys
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the files attached to a client.
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientFiles: async (
      clientId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceListClientFiles', 'clientId', clientId)
      const localVarPath = `/api/v1/clients/{clientId}/files`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists countries for administration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListCountriesAdmin: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/admin/references/countries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the sites and campaigns clients actually came through, under their lead source, as branches of the source filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListLeadSourceBreakdown: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/lead-sources/breakdown`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists lead sources for administration, including inactive ones.
     * @param {boolean} [includeInactive] Include sources that are no longer offered. Useful when rendering clients attributed to one of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListLeadSourcesAdmin: async (
      includeInactive?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/admin/references/lead-sources`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (includeInactive !== undefined) {
        localVarQueryParameter['includeInactive'] = includeInactive
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Records that someone downloaded a client\'s file, so the history shows who took what.
     * @param {string} clientId
     * @param {string} fileId
     * @param {ClientDataServiceLogClientFileDownloadBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceLogClientFileDownload: async (
      clientId: string,
      fileId: string,
      body: ClientDataServiceLogClientFileDownloadBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceLogClientFileDownload', 'clientId', clientId)
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists('clientDataServiceLogClientFileDownload', 'fileId', fileId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceLogClientFileDownload', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/files/{fileId}/download-log`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'fileId'}}`, encodeURIComponent(String(fileId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Takes a label off a client and returns the labels it has afterwards.
     * @param {string} clientId
     * @param {string} tagKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceRemoveClientTag: async (
      clientId: string,
      tagKey: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceRemoveClientTag', 'clientId', clientId)
      // verify required parameter 'tagKey' is not null or undefined
      assertParamExists('clientDataServiceRemoveClientTag', 'tagKey', tagKey)
      const localVarPath = `/api/v1/clients/{clientId}/tags/{tagKey}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'tagKey'}}`, encodeURIComponent(String(tagKey)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Settles the claim that a client an agent submitted was already in the company\'s books: either hands the client over to that agent or leaves the card where it is. Either way the \"Duplicate\" label comes off and the card stops showing up in the duplicates widget.
     * @param {string} clientId
     * @param {ClientDataServiceResolveClientDuplicateBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceResolveClientDuplicate: async (
      clientId: string,
      body: ClientDataServiceResolveClientDuplicateBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceResolveClientDuplicate', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceResolveClientDuplicate', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/duplicate/resolve`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Resolves user identifiers into names, including people who have since left. Available to any authenticated caller, because manager names appear on every screen and not only in management reports.
     * @param {V1ResolveUsersRequest} body User identifiers to resolve into names. People who have left are included, so that historical references to them still read correctly.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceResolveUsers: async (
      body: V1ResolveUsersRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceResolveUsers', 'body', body)
      const localVarPath = `/api/v1/references/users/resolve`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Searches cities by name, for the city picker on a client card.
     * @param {string} [query] Text to match against city names. At least two characters.
     * @param {string} [countryId] Search only within this country.
     * @param {number} [limit] Most results to return. Ten by default, fifty at most.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceSearchCities: async (
      query?: string,
      countryId?: string,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/references/cities/search`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      if (countryId !== undefined) {
        localVarQueryParameter['countryId'] = countryId
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Hands a manager\'s whole live portfolio over to another manager. Archived and deleted clients are left alone, and open deals follow their clients.
     * @param {V1TransferManagerClientsRequest} body Whose portfolio to hand over, and to whom. Archived and deleted clients stay with the manager who had them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceTransferManagerClients: async (
      body: V1TransferManagerClientsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceTransferManagerClients', 'body', body)
      const localVarPath = `/api/v1/clients/transfer-manager`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes an archive reason.
     * @param {string} id
     * @param {ClientDataServiceUpdateArchiveReasonBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateArchiveReason: async (
      id: string,
      body: ClientDataServiceUpdateArchiveReasonBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceUpdateArchiveReason', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateArchiveReason', 'body', body)
      const localVarPath = `/api/v1/admin/references/archive-reasons/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes a client. Fields left out keep their current values.
     * @param {string} clientId
     * @param {ClientDataServiceUpdateClientBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateClient: async (
      clientId: string,
      body: ClientDataServiceUpdateClientBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceUpdateClient', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateClient', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Renames an attached file or changes its description. The file itself is untouched.
     * @param {string} clientId
     * @param {string} fileId
     * @param {ClientDataServiceUpdateClientFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateClientFile: async (
      clientId: string,
      fileId: string,
      body: ClientDataServiceUpdateClientFileBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceUpdateClientFile', 'clientId', clientId)
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists('clientDataServiceUpdateClientFile', 'fileId', fileId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateClientFile', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/files/{fileId}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'fileId'}}`, encodeURIComponent(String(fileId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes a country.
     * @param {string} id
     * @param {ClientDataServiceUpdateCountryBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateCountry: async (
      id: string,
      body: ClientDataServiceUpdateCountryBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceUpdateCountry', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateCountry', 'body', body)
      const localVarPath = `/api/v1/admin/references/countries/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes a lead source.
     * @param {string} id
     * @param {ClientDataServiceUpdateLeadSourceBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateLeadSource: async (
      id: string,
      body: ClientDataServiceUpdateLeadSourceBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('clientDataServiceUpdateLeadSource', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateLeadSource', 'body', body)
      const localVarPath = `/api/v1/admin/references/lead-sources/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Rewrites a note.
     * @param {string} clientId
     * @param {string} noteId
     * @param {ClientDataServiceUpdateManagerNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateManagerNote: async (
      clientId: string,
      noteId: string,
      body: ClientDataServiceUpdateManagerNoteBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('clientDataServiceUpdateManagerNote', 'clientId', clientId)
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists('clientDataServiceUpdateManagerNote', 'noteId', noteId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('clientDataServiceUpdateManagerNote', 'body', body)
      const localVarPath = `/api/v1/clients/{clientId}/notes/{noteId}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'noteId'}}`, encodeURIComponent(String(noteId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ClientDataServiceApi - functional programming interface
 * @export
 */
export const ClientDataServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ClientDataServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Attaches an already uploaded file to a client.
     * @param {string} clientId
     * @param {ClientDataServiceAddClientFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceAddClientFile(
      clientId: string,
      body: ClientDataServiceAddClientFileBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AddClientFileResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceAddClientFile(
        clientId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceAddClientFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Puts a label on a client and returns the labels it has afterwards.
     * @param {string} clientId
     * @param {ClientDataServiceAddClientTagBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceAddClientTag(
      clientId: string,
      body: ClientDataServiceAddClientTagBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ClientTagsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceAddClientTag(
        clientId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceAddClientTag']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds a note to a client.
     * @param {string} clientId
     * @param {ClientDataServiceAddManagerNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceAddManagerNote(
      clientId: string,
      body: ClientDataServiceAddManagerNoteBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ManagerNote>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceAddManagerNote(
        clientId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceAddManagerNote']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes the responsible manager of many clients at once.
     * @param {V1BulkUpdateClientsRequest} body Which clients to change, and how.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceBulkUpdateClients(
      body: V1BulkUpdateClientsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1BulkUpdateClientsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceBulkUpdateClients(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceBulkUpdateClients']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds an archive reason.
     * @param {V1CreateArchiveReasonRequest} body A new archive reason. Shaped exactly like a lead source, because the sales report groups closed leads by the key of the reason they were closed with.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceCreateArchiveReason(
      body: V1CreateArchiveReasonRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateArchiveReasonResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceCreateArchiveReason(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceCreateArchiveReason']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Creates a full client card from the CRM.
     * @param {V1Client} client The client card. Naming a responsible manager assigns the client straight away; leaving it empty hands the client to the automatic distribution.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceCreateClient(
      client: V1Client,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Client>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceCreateClient(
        client,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceCreateClient']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * The rules are looser than for a client created by a manager, because a web form asks for very little: a lead with only a phone number still has to be recorded.
     * @summary Creates a client from a form filled in on the public website.
     * @param {V1Client} client The client card. Naming a responsible manager assigns the client straight away; leaving it empty hands the client to the automatic distribution.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceCreateClientFromFormData(
      client: V1Client,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Client>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceCreateClientFromFormData(client, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceCreateClientFromFormData']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds a country.
     * @param {V1CreateCountryRequest} body A new country.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceCreateCountry(
      body: V1CreateCountryRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateCountryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceCreateCountry(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceCreateCountry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds a lead source.
     * @param {V1CreateLeadSourceRequest} body A new lead source. Names are required in all three languages, because the source shows up on client cards in every locale.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceCreateLeadSource(
      body: V1CreateLeadSourceRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateLeadSourceResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceCreateLeadSource(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceCreateLeadSource']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Removes an archive reason. Clients already archived with it keep it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteArchiveReason(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceDeleteArchiveReason(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteArchiveReason']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Removes one way of contacting a client and returns the client afterwards.
     * @param {string} clientId
     * @param {string} contactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteClientContact(
      clientId: string,
      contactId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Client>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceDeleteClientContact(
          clientId,
          contactId,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteClientContact']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Detaches a file from a client.
     * @param {string} clientId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteClientFile(
      clientId: string,
      fileId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceDeleteClientFile(
        clientId,
        fileId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteClientFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Removes a country.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteCountry(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceDeleteCountry(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteCountry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Removes a lead source. Clients already attributed to it keep it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteLeadSource(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceDeleteLeadSource(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteLeadSource']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a note.
     * @param {string} clientId
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceDeleteManagerNote(
      clientId: string,
      noteId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceDeleteManagerNote(
        clientId,
        noteId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceDeleteManagerNote']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the reasons a client can be archived for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetArchiveReasons(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetArchiveReasonsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceGetArchiveReasons(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetArchiveReasons']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one client card in full.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetClient(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Client>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceGetClient(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetClient']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * The list is fixed in code rather than kept in a table: what counts as \"filled in\" differs from field to field, and that rule lives next to the card it describes.
     * @summary Lists the client card fields a funnel stage can require to be filled in before a deal moves onto it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetClientFieldDefinitions(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<V1GetClientFieldDefinitionsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceGetClientFieldDefinitions(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetClientFieldDefinitions']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the countries a client can belong to, with their dialling codes and phone number lengths.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetCountriesReferences(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetCountriesResponse>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceGetCountriesReferences(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetCountriesReferences']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the client counters of the caller\'s dashboard: how many clients there are and how that changed.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Defaults to \&quot;month\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetDashboardMetrics(
      period?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1DashboardMetricsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceGetDashboardMetrics(period, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetDashboardMetrics']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the lead sources a client can be attributed to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetLeadSources(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetLeadSourcesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceGetLeadSources(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetLeadSources']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: restricted to administrators and the head of sales.
     * @summary Lists the managers clients can be assigned to.
     * @param {string} [role] Role to list: \&quot;manager\&quot; by default, or \&quot;support_manager\&quot; for the managers who can be added to a deal as helpers. The latter is available to an ordinary manager too, because the responsible manager picks the helper themselves.
     * @param {boolean} [activeOnly] True returns only people still working here, which is what a picker for \&quot;who should take these clients\&quot; needs. False, the default, also returns people who have left: their names are still needed by filters and by historical records.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetManagers(
      role?: string,
      activeOnly?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetManagersResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceGetManagers(
        role,
        activeOnly,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetManagers']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the labels a client can carry.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceGetTags(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetTagsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceGetTags(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceGetTags']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists archive reasons for administration, including inactive ones.
     * @param {boolean} [includeInactive] Include reasons that are no longer offered. Useful when rendering clients archived with one of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListArchiveReasonsAdmin(
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListArchiveReasonsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceListArchiveReasonsAdmin(
          includeInactive,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListArchiveReasonsAdmin']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the history of a client: who changed what and when.
     * @param {string} clientId
     * @param {ClientDataServiceListClientChangeLogsActionTypeEnum} [actionType] Return only entries of this kind. Left out, every kind is returned.   - CLIENT_CHANGE_ACTION_TYPE_CREATED: The client was created.  - CLIENT_CHANGE_ACTION_TYPE_UPDATED: Fields of the client were edited.  - CLIENT_CHANGE_ACTION_TYPE_STAGE_CHANGED: The stage changed.  - CLIENT_CHANGE_ACTION_TYPE_STATUS_CHANGED: The status changed.  - CLIENT_CHANGE_ACTION_TYPE_TASK_CREATED: A task was created.  - CLIENT_CHANGE_ACTION_TYPE_TASK_UPDATED: A task was edited.  - CLIENT_CHANGE_ACTION_TYPE_TASK_COMPLETED: A task was completed.  - CLIENT_CHANGE_ACTION_TYPE_TASK_DELETED: A task was deleted.  - CLIENT_CHANGE_ACTION_TYPE_NOTE_ADDED: A note was added.  - CLIENT_CHANGE_ACTION_TYPE_NOTE_UPDATED: A note was edited.  - CLIENT_CHANGE_ACTION_TYPE_NOTE_DELETED: A note was deleted.  - CLIENT_CHANGE_ACTION_TYPE_MANAGER_ASSIGNED: A manager was made responsible for the client.  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_ADDED: A way of contacting the client was added.  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_REMOVED: A way of contacting the client was removed.  - CLIENT_CHANGE_ACTION_TYPE_DELETED: The client was deleted.  - CLIENT_CHANGE_ACTION_TYPE_FILE_UPLOADED: A file was uploaded.  - CLIENT_CHANGE_ACTION_TYPE_FILE_DOWNLOADED: A file was downloaded.
     * @param {number} [limit] Most entries to return. Fifty by default.
     * @param {number} [offset] How many entries to skip.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListClientChangeLogs(
      clientId: string,
      actionType?: ClientDataServiceListClientChangeLogsActionTypeEnum,
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListClientChangeLogsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceListClientChangeLogs(
          clientId,
          actionType,
          limit,
          offset,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListClientChangeLogs']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists clients with filters, sorting and paging.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [responsibleManagerId]
     * @param {string} [leadSource]
     * @param {Array<string>} [statuses] Statuses to include.
     * @param {Array<string>} [leadSources] Lead sources to include.
     * @param {string} [dateFrom] Only clients created at or after this moment.
     * @param {string} [dateTo] Only clients created at or before this moment.
     * @param {string} [searchQuery] Full-text search over name, email address and phone number.
     * @param {string} [language] Language the client prefers to be addressed in.
     * @param {boolean} [hasDeal] True returns only clients that have a deal, false only those that have none. Left out, the filter is not applied.
     * @param {boolean} [isArchived] True returns only archived clients. False or left out returns only active ones.
     * @param {boolean} [hasResponsibleManager] True returns only clients that have a responsible manager, false only those without one. Left out, the filter is not applied. It backs the \&quot;my clients\&quot; and \&quot;unassigned\&quot; presets, and is ignored for callers who can see only their own clients anyway.
     * @param {string} [agentId] Agent who brought the client in.
     * @param {boolean} [hasAgent] True returns only clients brought in by an agent, false only those that came in directly. Left out, the filter is not applied.
     * @param {string} [agentDuplicateStatus] Whether an agent lead turned out to be someone already known: not_checked, unique, duplicate_pending, duplicate_confirmed or rejected. Whatever the filter says, the caller still only sees the clients their role allows.
     * @param {Array<string>} [tagKeys] Labels the client must carry. Several keys match a client carrying any one of them.
     * @param {Array<string>} [archiveReasonIds] Archive reasons to include. Several match a client archived for any one of them. Only meaningful together with the archived filter.
     * @param {Array<string>} [cityIds] Cities to include. A client counts as matching when its city comes from the dictionary; a manually typed city never matches.
     * @param {string} [countryId] Country of the client.
     * @param {Array<string>} [sourceKeys] Where the leads came from, at any depth of the source tree: a lead source alone, a site within it, or a campaign on that site. A client matches if it matches any of the keys.  A key is \&quot;&lt;lead_source_id&gt;\&quot;, \&quot;&lt;lead_source_id&gt;|&lt;landing_slug&gt;\&quot;, \&quot;&lt;lead_source_id&gt;|&lt;landing_slug&gt;|campaign:&lt;utm_campaign&gt;\&quot; or \&quot;&lt;lead_source_id&gt;|&lt;landing_slug&gt;|source:&lt;utm_source&gt;\&quot;; the site may be empty at the campaign level. Keys come from ListLeadSourceBreakdown.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListClientData(
      paginationPage?: string,
      paginationPerPage?: string,
      responsibleManagerId?: string,
      leadSource?: string,
      statuses?: Array<string>,
      leadSources?: Array<string>,
      dateFrom?: string,
      dateTo?: string,
      searchQuery?: string,
      language?: string,
      hasDeal?: boolean,
      isArchived?: boolean,
      hasResponsibleManager?: boolean,
      agentId?: string,
      hasAgent?: boolean,
      agentDuplicateStatus?: string,
      tagKeys?: Array<string>,
      archiveReasonIds?: Array<string>,
      cityIds?: Array<string>,
      countryId?: string,
      sourceKeys?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListClientDataResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceListClientData(
        paginationPage,
        paginationPerPage,
        responsibleManagerId,
        leadSource,
        statuses,
        leadSources,
        dateFrom,
        dateTo,
        searchQuery,
        language,
        hasDeal,
        isArchived,
        hasResponsibleManager,
        agentId,
        hasAgent,
        agentDuplicateStatus,
        tagKeys,
        archiveReasonIds,
        cityIds,
        countryId,
        sourceKeys,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListClientData']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the files attached to a client.
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListClientFiles(
      clientId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListClientFilesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceListClientFiles(
        clientId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListClientFiles']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists countries for administration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListCountriesAdmin(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListCountriesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceListCountriesAdmin(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListCountriesAdmin']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the sites and campaigns clients actually came through, under their lead source, as branches of the source filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListLeadSourceBreakdown(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListLeadSourceBreakdownResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceListLeadSourceBreakdown(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListLeadSourceBreakdown']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists lead sources for administration, including inactive ones.
     * @param {boolean} [includeInactive] Include sources that are no longer offered. Useful when rendering clients attributed to one of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceListLeadSourcesAdmin(
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListLeadSourcesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceListLeadSourcesAdmin(
          includeInactive,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceListLeadSourcesAdmin']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Records that someone downloaded a client\'s file, so the history shows who took what.
     * @param {string} clientId
     * @param {string} fileId
     * @param {ClientDataServiceLogClientFileDownloadBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceLogClientFileDownload(
      clientId: string,
      fileId: string,
      body: ClientDataServiceLogClientFileDownloadBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceLogClientFileDownload(
          clientId,
          fileId,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceLogClientFileDownload']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Takes a label off a client and returns the labels it has afterwards.
     * @param {string} clientId
     * @param {string} tagKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceRemoveClientTag(
      clientId: string,
      tagKey: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ClientTagsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceRemoveClientTag(
        clientId,
        tagKey,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceRemoveClientTag']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Settles the claim that a client an agent submitted was already in the company\'s books: either hands the client over to that agent or leaves the card where it is. Either way the \"Duplicate\" label comes off and the card stops showing up in the duplicates widget.
     * @param {string} clientId
     * @param {ClientDataServiceResolveClientDuplicateBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceResolveClientDuplicate(
      clientId: string,
      body: ClientDataServiceResolveClientDuplicateBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ResolveClientDuplicateResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceResolveClientDuplicate(
          clientId,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceResolveClientDuplicate']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Resolves user identifiers into names, including people who have since left. Available to any authenticated caller, because manager names appear on every screen and not only in management reports.
     * @param {V1ResolveUsersRequest} body User identifiers to resolve into names. People who have left are included, so that historical references to them still read correctly.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceResolveUsers(
      body: V1ResolveUsersRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ResolveUsersResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceResolveUsers(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceResolveUsers']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Searches cities by name, for the city picker on a client card.
     * @param {string} [query] Text to match against city names. At least two characters.
     * @param {string} [countryId] Search only within this country.
     * @param {number} [limit] Most results to return. Ten by default, fifty at most.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceSearchCities(
      query?: string,
      countryId?: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SearchCitiesResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceSearchCities(
        query,
        countryId,
        limit,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceSearchCities']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Hands a manager\'s whole live portfolio over to another manager. Archived and deleted clients are left alone, and open deals follow their clients.
     * @param {V1TransferManagerClientsRequest} body Whose portfolio to hand over, and to whom. Archived and deleted clients stay with the manager who had them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceTransferManagerClients(
      body: V1TransferManagerClientsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1TransferManagerClientsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceTransferManagerClients(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceTransferManagerClients']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes an archive reason.
     * @param {string} id
     * @param {ClientDataServiceUpdateArchiveReasonBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateArchiveReason(
      id: string,
      body: ClientDataServiceUpdateArchiveReasonBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateArchiveReasonResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.clientDataServiceUpdateArchiveReason(id, body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateArchiveReason']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes a client. Fields left out keep their current values.
     * @param {string} clientId
     * @param {ClientDataServiceUpdateClientBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateClient(
      clientId: string,
      body: ClientDataServiceUpdateClientBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Client>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceUpdateClient(
        clientId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateClient']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Renames an attached file or changes its description. The file itself is untouched.
     * @param {string} clientId
     * @param {string} fileId
     * @param {ClientDataServiceUpdateClientFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateClientFile(
      clientId: string,
      fileId: string,
      body: ClientDataServiceUpdateClientFileBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateClientFileResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceUpdateClientFile(
        clientId,
        fileId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateClientFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes a country.
     * @param {string} id
     * @param {ClientDataServiceUpdateCountryBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateCountry(
      id: string,
      body: ClientDataServiceUpdateCountryBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateCountryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceUpdateCountry(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateCountry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes a lead source.
     * @param {string} id
     * @param {ClientDataServiceUpdateLeadSourceBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateLeadSource(
      id: string,
      body: ClientDataServiceUpdateLeadSourceBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateLeadSourceResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceUpdateLeadSource(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateLeadSource']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Rewrites a note.
     * @param {string} clientId
     * @param {string} noteId
     * @param {ClientDataServiceUpdateManagerNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clientDataServiceUpdateManagerNote(
      clientId: string,
      noteId: string,
      body: ClientDataServiceUpdateManagerNoteBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ManagerNote>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clientDataServiceUpdateManagerNote(
        clientId,
        noteId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClientDataServiceApi.clientDataServiceUpdateManagerNote']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ClientDataServiceApi - factory interface
 * @export
 */
export const ClientDataServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ClientDataServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Attaches an already uploaded file to a client.
     * @param {string} clientId
     * @param {ClientDataServiceAddClientFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceAddClientFile(
      clientId: string,
      body: ClientDataServiceAddClientFileBody,
      options?: any,
    ): AxiosPromise<V1AddClientFileResponse> {
      return localVarFp
        .clientDataServiceAddClientFile(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Puts a label on a client and returns the labels it has afterwards.
     * @param {string} clientId
     * @param {ClientDataServiceAddClientTagBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceAddClientTag(
      clientId: string,
      body: ClientDataServiceAddClientTagBody,
      options?: any,
    ): AxiosPromise<V1ClientTagsResponse> {
      return localVarFp
        .clientDataServiceAddClientTag(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds a note to a client.
     * @param {string} clientId
     * @param {ClientDataServiceAddManagerNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceAddManagerNote(
      clientId: string,
      body: ClientDataServiceAddManagerNoteBody,
      options?: any,
    ): AxiosPromise<V1ManagerNote> {
      return localVarFp
        .clientDataServiceAddManagerNote(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes the responsible manager of many clients at once.
     * @param {V1BulkUpdateClientsRequest} body Which clients to change, and how.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceBulkUpdateClients(
      body: V1BulkUpdateClientsRequest,
      options?: any,
    ): AxiosPromise<V1BulkUpdateClientsResponse> {
      return localVarFp
        .clientDataServiceBulkUpdateClients(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds an archive reason.
     * @param {V1CreateArchiveReasonRequest} body A new archive reason. Shaped exactly like a lead source, because the sales report groups closed leads by the key of the reason they were closed with.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateArchiveReason(
      body: V1CreateArchiveReasonRequest,
      options?: any,
    ): AxiosPromise<V1CreateArchiveReasonResponse> {
      return localVarFp
        .clientDataServiceCreateArchiveReason(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Creates a full client card from the CRM.
     * @param {V1Client} client The client card. Naming a responsible manager assigns the client straight away; leaving it empty hands the client to the automatic distribution.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateClient(client: V1Client, options?: any): AxiosPromise<V1Client> {
      return localVarFp
        .clientDataServiceCreateClient(client, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * The rules are looser than for a client created by a manager, because a web form asks for very little: a lead with only a phone number still has to be recorded.
     * @summary Creates a client from a form filled in on the public website.
     * @param {V1Client} client The client card. Naming a responsible manager assigns the client straight away; leaving it empty hands the client to the automatic distribution.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateClientFromFormData(
      client: V1Client,
      options?: any,
    ): AxiosPromise<V1Client> {
      return localVarFp
        .clientDataServiceCreateClientFromFormData(client, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds a country.
     * @param {V1CreateCountryRequest} body A new country.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateCountry(
      body: V1CreateCountryRequest,
      options?: any,
    ): AxiosPromise<V1CreateCountryResponse> {
      return localVarFp
        .clientDataServiceCreateCountry(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds a lead source.
     * @param {V1CreateLeadSourceRequest} body A new lead source. Names are required in all three languages, because the source shows up on client cards in every locale.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceCreateLeadSource(
      body: V1CreateLeadSourceRequest,
      options?: any,
    ): AxiosPromise<V1CreateLeadSourceResponse> {
      return localVarFp
        .clientDataServiceCreateLeadSource(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Removes an archive reason. Clients already archived with it keep it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteArchiveReason(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceDeleteArchiveReason(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Removes one way of contacting a client and returns the client afterwards.
     * @param {string} clientId
     * @param {string} contactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteClientContact(
      clientId: string,
      contactId: string,
      options?: any,
    ): AxiosPromise<V1Client> {
      return localVarFp
        .clientDataServiceDeleteClientContact(clientId, contactId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Detaches a file from a client.
     * @param {string} clientId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteClientFile(
      clientId: string,
      fileId: string,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceDeleteClientFile(clientId, fileId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Removes a country.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteCountry(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceDeleteCountry(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Removes a lead source. Clients already attributed to it keep it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteLeadSource(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceDeleteLeadSource(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a note.
     * @param {string} clientId
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceDeleteManagerNote(
      clientId: string,
      noteId: string,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceDeleteManagerNote(clientId, noteId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the reasons a client can be archived for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetArchiveReasons(options?: any): AxiosPromise<V1GetArchiveReasonsResponse> {
      return localVarFp
        .clientDataServiceGetArchiveReasons(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one client card in full.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetClient(id: string, options?: any): AxiosPromise<V1Client> {
      return localVarFp
        .clientDataServiceGetClient(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * The list is fixed in code rather than kept in a table: what counts as \"filled in\" differs from field to field, and that rule lives next to the card it describes.
     * @summary Lists the client card fields a funnel stage can require to be filled in before a deal moves onto it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetClientFieldDefinitions(
      options?: any,
    ): AxiosPromise<V1GetClientFieldDefinitionsResponse> {
      return localVarFp
        .clientDataServiceGetClientFieldDefinitions(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the countries a client can belong to, with their dialling codes and phone number lengths.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetCountriesReferences(options?: any): AxiosPromise<V1GetCountriesResponse> {
      return localVarFp
        .clientDataServiceGetCountriesReferences(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the client counters of the caller\'s dashboard: how many clients there are and how that changed.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Defaults to \&quot;month\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetDashboardMetrics(
      period?: string,
      options?: any,
    ): AxiosPromise<V1DashboardMetricsResponse> {
      return localVarFp
        .clientDataServiceGetDashboardMetrics(period, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the lead sources a client can be attributed to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetLeadSources(options?: any): AxiosPromise<V1GetLeadSourcesResponse> {
      return localVarFp
        .clientDataServiceGetLeadSources(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: restricted to administrators and the head of sales.
     * @summary Lists the managers clients can be assigned to.
     * @param {string} [role] Role to list: \&quot;manager\&quot; by default, or \&quot;support_manager\&quot; for the managers who can be added to a deal as helpers. The latter is available to an ordinary manager too, because the responsible manager picks the helper themselves.
     * @param {boolean} [activeOnly] True returns only people still working here, which is what a picker for \&quot;who should take these clients\&quot; needs. False, the default, also returns people who have left: their names are still needed by filters and by historical records.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetManagers(
      role?: string,
      activeOnly?: boolean,
      options?: any,
    ): AxiosPromise<V1GetManagersResponse> {
      return localVarFp
        .clientDataServiceGetManagers(role, activeOnly, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the labels a client can carry.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceGetTags(options?: any): AxiosPromise<V1GetTagsResponse> {
      return localVarFp
        .clientDataServiceGetTags(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists archive reasons for administration, including inactive ones.
     * @param {boolean} [includeInactive] Include reasons that are no longer offered. Useful when rendering clients archived with one of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListArchiveReasonsAdmin(
      includeInactive?: boolean,
      options?: any,
    ): AxiosPromise<V1ListArchiveReasonsResponse> {
      return localVarFp
        .clientDataServiceListArchiveReasonsAdmin(includeInactive, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the history of a client: who changed what and when.
     * @param {string} clientId
     * @param {ClientDataServiceListClientChangeLogsActionTypeEnum} [actionType] Return only entries of this kind. Left out, every kind is returned.   - CLIENT_CHANGE_ACTION_TYPE_CREATED: The client was created.  - CLIENT_CHANGE_ACTION_TYPE_UPDATED: Fields of the client were edited.  - CLIENT_CHANGE_ACTION_TYPE_STAGE_CHANGED: The stage changed.  - CLIENT_CHANGE_ACTION_TYPE_STATUS_CHANGED: The status changed.  - CLIENT_CHANGE_ACTION_TYPE_TASK_CREATED: A task was created.  - CLIENT_CHANGE_ACTION_TYPE_TASK_UPDATED: A task was edited.  - CLIENT_CHANGE_ACTION_TYPE_TASK_COMPLETED: A task was completed.  - CLIENT_CHANGE_ACTION_TYPE_TASK_DELETED: A task was deleted.  - CLIENT_CHANGE_ACTION_TYPE_NOTE_ADDED: A note was added.  - CLIENT_CHANGE_ACTION_TYPE_NOTE_UPDATED: A note was edited.  - CLIENT_CHANGE_ACTION_TYPE_NOTE_DELETED: A note was deleted.  - CLIENT_CHANGE_ACTION_TYPE_MANAGER_ASSIGNED: A manager was made responsible for the client.  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_ADDED: A way of contacting the client was added.  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_REMOVED: A way of contacting the client was removed.  - CLIENT_CHANGE_ACTION_TYPE_DELETED: The client was deleted.  - CLIENT_CHANGE_ACTION_TYPE_FILE_UPLOADED: A file was uploaded.  - CLIENT_CHANGE_ACTION_TYPE_FILE_DOWNLOADED: A file was downloaded.
     * @param {number} [limit] Most entries to return. Fifty by default.
     * @param {number} [offset] How many entries to skip.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientChangeLogs(
      clientId: string,
      actionType?: ClientDataServiceListClientChangeLogsActionTypeEnum,
      limit?: number,
      offset?: number,
      options?: any,
    ): AxiosPromise<V1ListClientChangeLogsResponse> {
      return localVarFp
        .clientDataServiceListClientChangeLogs(clientId, actionType, limit, offset, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists clients with filters, sorting and paging.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [responsibleManagerId]
     * @param {string} [leadSource]
     * @param {Array<string>} [statuses] Statuses to include.
     * @param {Array<string>} [leadSources] Lead sources to include.
     * @param {string} [dateFrom] Only clients created at or after this moment.
     * @param {string} [dateTo] Only clients created at or before this moment.
     * @param {string} [searchQuery] Full-text search over name, email address and phone number.
     * @param {string} [language] Language the client prefers to be addressed in.
     * @param {boolean} [hasDeal] True returns only clients that have a deal, false only those that have none. Left out, the filter is not applied.
     * @param {boolean} [isArchived] True returns only archived clients. False or left out returns only active ones.
     * @param {boolean} [hasResponsibleManager] True returns only clients that have a responsible manager, false only those without one. Left out, the filter is not applied. It backs the \&quot;my clients\&quot; and \&quot;unassigned\&quot; presets, and is ignored for callers who can see only their own clients anyway.
     * @param {string} [agentId] Agent who brought the client in.
     * @param {boolean} [hasAgent] True returns only clients brought in by an agent, false only those that came in directly. Left out, the filter is not applied.
     * @param {string} [agentDuplicateStatus] Whether an agent lead turned out to be someone already known: not_checked, unique, duplicate_pending, duplicate_confirmed or rejected. Whatever the filter says, the caller still only sees the clients their role allows.
     * @param {Array<string>} [tagKeys] Labels the client must carry. Several keys match a client carrying any one of them.
     * @param {Array<string>} [archiveReasonIds] Archive reasons to include. Several match a client archived for any one of them. Only meaningful together with the archived filter.
     * @param {Array<string>} [cityIds] Cities to include. A client counts as matching when its city comes from the dictionary; a manually typed city never matches.
     * @param {string} [countryId] Country of the client.
     * @param {Array<string>} [sourceKeys] Where the leads came from, at any depth of the source tree: a lead source alone, a site within it, or a campaign on that site. A client matches if it matches any of the keys.  A key is \&quot;&lt;lead_source_id&gt;\&quot;, \&quot;&lt;lead_source_id&gt;|&lt;landing_slug&gt;\&quot;, \&quot;&lt;lead_source_id&gt;|&lt;landing_slug&gt;|campaign:&lt;utm_campaign&gt;\&quot; or \&quot;&lt;lead_source_id&gt;|&lt;landing_slug&gt;|source:&lt;utm_source&gt;\&quot;; the site may be empty at the campaign level. Keys come from ListLeadSourceBreakdown.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientData(
      paginationPage?: string,
      paginationPerPage?: string,
      responsibleManagerId?: string,
      leadSource?: string,
      statuses?: Array<string>,
      leadSources?: Array<string>,
      dateFrom?: string,
      dateTo?: string,
      searchQuery?: string,
      language?: string,
      hasDeal?: boolean,
      isArchived?: boolean,
      hasResponsibleManager?: boolean,
      agentId?: string,
      hasAgent?: boolean,
      agentDuplicateStatus?: string,
      tagKeys?: Array<string>,
      archiveReasonIds?: Array<string>,
      cityIds?: Array<string>,
      countryId?: string,
      sourceKeys?: Array<string>,
      options?: any,
    ): AxiosPromise<V1ListClientDataResponse> {
      return localVarFp
        .clientDataServiceListClientData(
          paginationPage,
          paginationPerPage,
          responsibleManagerId,
          leadSource,
          statuses,
          leadSources,
          dateFrom,
          dateTo,
          searchQuery,
          language,
          hasDeal,
          isArchived,
          hasResponsibleManager,
          agentId,
          hasAgent,
          agentDuplicateStatus,
          tagKeys,
          archiveReasonIds,
          cityIds,
          countryId,
          sourceKeys,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the files attached to a client.
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListClientFiles(
      clientId: string,
      options?: any,
    ): AxiosPromise<V1ListClientFilesResponse> {
      return localVarFp
        .clientDataServiceListClientFiles(clientId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists countries for administration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListCountriesAdmin(options?: any): AxiosPromise<V1ListCountriesResponse> {
      return localVarFp
        .clientDataServiceListCountriesAdmin(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the sites and campaigns clients actually came through, under their lead source, as branches of the source filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListLeadSourceBreakdown(
      options?: any,
    ): AxiosPromise<V1ListLeadSourceBreakdownResponse> {
      return localVarFp
        .clientDataServiceListLeadSourceBreakdown(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists lead sources for administration, including inactive ones.
     * @param {boolean} [includeInactive] Include sources that are no longer offered. Useful when rendering clients attributed to one of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceListLeadSourcesAdmin(
      includeInactive?: boolean,
      options?: any,
    ): AxiosPromise<V1ListLeadSourcesResponse> {
      return localVarFp
        .clientDataServiceListLeadSourcesAdmin(includeInactive, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Records that someone downloaded a client\'s file, so the history shows who took what.
     * @param {string} clientId
     * @param {string} fileId
     * @param {ClientDataServiceLogClientFileDownloadBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceLogClientFileDownload(
      clientId: string,
      fileId: string,
      body: ClientDataServiceLogClientFileDownloadBody,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .clientDataServiceLogClientFileDownload(clientId, fileId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Takes a label off a client and returns the labels it has afterwards.
     * @param {string} clientId
     * @param {string} tagKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceRemoveClientTag(
      clientId: string,
      tagKey: string,
      options?: any,
    ): AxiosPromise<V1ClientTagsResponse> {
      return localVarFp
        .clientDataServiceRemoveClientTag(clientId, tagKey, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Settles the claim that a client an agent submitted was already in the company\'s books: either hands the client over to that agent or leaves the card where it is. Either way the \"Duplicate\" label comes off and the card stops showing up in the duplicates widget.
     * @param {string} clientId
     * @param {ClientDataServiceResolveClientDuplicateBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceResolveClientDuplicate(
      clientId: string,
      body: ClientDataServiceResolveClientDuplicateBody,
      options?: any,
    ): AxiosPromise<V1ResolveClientDuplicateResponse> {
      return localVarFp
        .clientDataServiceResolveClientDuplicate(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Resolves user identifiers into names, including people who have since left. Available to any authenticated caller, because manager names appear on every screen and not only in management reports.
     * @param {V1ResolveUsersRequest} body User identifiers to resolve into names. People who have left are included, so that historical references to them still read correctly.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceResolveUsers(
      body: V1ResolveUsersRequest,
      options?: any,
    ): AxiosPromise<V1ResolveUsersResponse> {
      return localVarFp
        .clientDataServiceResolveUsers(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Searches cities by name, for the city picker on a client card.
     * @param {string} [query] Text to match against city names. At least two characters.
     * @param {string} [countryId] Search only within this country.
     * @param {number} [limit] Most results to return. Ten by default, fifty at most.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceSearchCities(
      query?: string,
      countryId?: string,
      limit?: number,
      options?: any,
    ): AxiosPromise<V1SearchCitiesResponse> {
      return localVarFp
        .clientDataServiceSearchCities(query, countryId, limit, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Hands a manager\'s whole live portfolio over to another manager. Archived and deleted clients are left alone, and open deals follow their clients.
     * @param {V1TransferManagerClientsRequest} body Whose portfolio to hand over, and to whom. Archived and deleted clients stay with the manager who had them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceTransferManagerClients(
      body: V1TransferManagerClientsRequest,
      options?: any,
    ): AxiosPromise<V1TransferManagerClientsResponse> {
      return localVarFp
        .clientDataServiceTransferManagerClients(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes an archive reason.
     * @param {string} id
     * @param {ClientDataServiceUpdateArchiveReasonBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateArchiveReason(
      id: string,
      body: ClientDataServiceUpdateArchiveReasonBody,
      options?: any,
    ): AxiosPromise<V1UpdateArchiveReasonResponse> {
      return localVarFp
        .clientDataServiceUpdateArchiveReason(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes a client. Fields left out keep their current values.
     * @param {string} clientId
     * @param {ClientDataServiceUpdateClientBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateClient(
      clientId: string,
      body: ClientDataServiceUpdateClientBody,
      options?: any,
    ): AxiosPromise<V1Client> {
      return localVarFp
        .clientDataServiceUpdateClient(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Renames an attached file or changes its description. The file itself is untouched.
     * @param {string} clientId
     * @param {string} fileId
     * @param {ClientDataServiceUpdateClientFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateClientFile(
      clientId: string,
      fileId: string,
      body: ClientDataServiceUpdateClientFileBody,
      options?: any,
    ): AxiosPromise<V1UpdateClientFileResponse> {
      return localVarFp
        .clientDataServiceUpdateClientFile(clientId, fileId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes a country.
     * @param {string} id
     * @param {ClientDataServiceUpdateCountryBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateCountry(
      id: string,
      body: ClientDataServiceUpdateCountryBody,
      options?: any,
    ): AxiosPromise<V1UpdateCountryResponse> {
      return localVarFp
        .clientDataServiceUpdateCountry(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes a lead source.
     * @param {string} id
     * @param {ClientDataServiceUpdateLeadSourceBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateLeadSource(
      id: string,
      body: ClientDataServiceUpdateLeadSourceBody,
      options?: any,
    ): AxiosPromise<V1UpdateLeadSourceResponse> {
      return localVarFp
        .clientDataServiceUpdateLeadSource(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Rewrites a note.
     * @param {string} clientId
     * @param {string} noteId
     * @param {ClientDataServiceUpdateManagerNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clientDataServiceUpdateManagerNote(
      clientId: string,
      noteId: string,
      body: ClientDataServiceUpdateManagerNoteBody,
      options?: any,
    ): AxiosPromise<V1ManagerNote> {
      return localVarFp
        .clientDataServiceUpdateManagerNote(clientId, noteId, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * ClientDataServiceApi - object-oriented interface
 * @export
 * @class ClientDataServiceApi
 * @extends {BaseAPI}
 */
export class ClientDataServiceApi extends BaseAPI {
  /**
   *
   * @summary Attaches an already uploaded file to a client.
   * @param {string} clientId
   * @param {ClientDataServiceAddClientFileBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceAddClientFile(
    clientId: string,
    body: ClientDataServiceAddClientFileBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceAddClientFile(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Puts a label on a client and returns the labels it has afterwards.
   * @param {string} clientId
   * @param {ClientDataServiceAddClientTagBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceAddClientTag(
    clientId: string,
    body: ClientDataServiceAddClientTagBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceAddClientTag(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds a note to a client.
   * @param {string} clientId
   * @param {ClientDataServiceAddManagerNoteBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceAddManagerNote(
    clientId: string,
    body: ClientDataServiceAddManagerNoteBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceAddManagerNote(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes the responsible manager of many clients at once.
   * @param {V1BulkUpdateClientsRequest} body Which clients to change, and how.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceBulkUpdateClients(
    body: V1BulkUpdateClientsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceBulkUpdateClients(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds an archive reason.
   * @param {V1CreateArchiveReasonRequest} body A new archive reason. Shaped exactly like a lead source, because the sales report groups closed leads by the key of the reason they were closed with.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceCreateArchiveReason(
    body: V1CreateArchiveReasonRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceCreateArchiveReason(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Creates a full client card from the CRM.
   * @param {V1Client} client The client card. Naming a responsible manager assigns the client straight away; leaving it empty hands the client to the automatic distribution.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceCreateClient(client: V1Client, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceCreateClient(client, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * The rules are looser than for a client created by a manager, because a web form asks for very little: a lead with only a phone number still has to be recorded.
   * @summary Creates a client from a form filled in on the public website.
   * @param {V1Client} client The client card. Naming a responsible manager assigns the client straight away; leaving it empty hands the client to the automatic distribution.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceCreateClientFromFormData(
    client: V1Client,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceCreateClientFromFormData(client, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds a country.
   * @param {V1CreateCountryRequest} body A new country.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceCreateCountry(
    body: V1CreateCountryRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceCreateCountry(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds a lead source.
   * @param {V1CreateLeadSourceRequest} body A new lead source. Names are required in all three languages, because the source shows up on client cards in every locale.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceCreateLeadSource(
    body: V1CreateLeadSourceRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceCreateLeadSource(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Removes an archive reason. Clients already archived with it keep it.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteArchiveReason(id: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteArchiveReason(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Removes one way of contacting a client and returns the client afterwards.
   * @param {string} clientId
   * @param {string} contactId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteClientContact(
    clientId: string,
    contactId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteClientContact(clientId, contactId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Detaches a file from a client.
   * @param {string} clientId
   * @param {string} fileId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteClientFile(
    clientId: string,
    fileId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteClientFile(clientId, fileId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Removes a country.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteCountry(id: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteCountry(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Removes a lead source. Clients already attributed to it keep it.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteLeadSource(id: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteLeadSource(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a note.
   * @param {string} clientId
   * @param {string} noteId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceDeleteManagerNote(
    clientId: string,
    noteId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceDeleteManagerNote(clientId, noteId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the reasons a client can be archived for.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetArchiveReasons(options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetArchiveReasons(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one client card in full.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetClient(id: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetClient(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * The list is fixed in code rather than kept in a table: what counts as \"filled in\" differs from field to field, and that rule lives next to the card it describes.
   * @summary Lists the client card fields a funnel stage can require to be filled in before a deal moves onto it.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetClientFieldDefinitions(options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetClientFieldDefinitions(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the countries a client can belong to, with their dialling codes and phone number lengths.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetCountriesReferences(options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetCountriesReferences(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the client counters of the caller\'s dashboard: how many clients there are and how that changed.
   * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Defaults to \&quot;month\&quot;.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetDashboardMetrics(period?: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetDashboardMetrics(period, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the lead sources a client can be attributed to.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetLeadSources(options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetLeadSources(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: restricted to administrators and the head of sales.
   * @summary Lists the managers clients can be assigned to.
   * @param {string} [role] Role to list: \&quot;manager\&quot; by default, or \&quot;support_manager\&quot; for the managers who can be added to a deal as helpers. The latter is available to an ordinary manager too, because the responsible manager picks the helper themselves.
   * @param {boolean} [activeOnly] True returns only people still working here, which is what a picker for \&quot;who should take these clients\&quot; needs. False, the default, also returns people who have left: their names are still needed by filters and by historical records.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetManagers(
    role?: string,
    activeOnly?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetManagers(role, activeOnly, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the labels a client can carry.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceGetTags(options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceGetTags(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists archive reasons for administration, including inactive ones.
   * @param {boolean} [includeInactive] Include reasons that are no longer offered. Useful when rendering clients archived with one of them.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListArchiveReasonsAdmin(
    includeInactive?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListArchiveReasonsAdmin(includeInactive, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the history of a client: who changed what and when.
   * @param {string} clientId
   * @param {ClientDataServiceListClientChangeLogsActionTypeEnum} [actionType] Return only entries of this kind. Left out, every kind is returned.   - CLIENT_CHANGE_ACTION_TYPE_CREATED: The client was created.  - CLIENT_CHANGE_ACTION_TYPE_UPDATED: Fields of the client were edited.  - CLIENT_CHANGE_ACTION_TYPE_STAGE_CHANGED: The stage changed.  - CLIENT_CHANGE_ACTION_TYPE_STATUS_CHANGED: The status changed.  - CLIENT_CHANGE_ACTION_TYPE_TASK_CREATED: A task was created.  - CLIENT_CHANGE_ACTION_TYPE_TASK_UPDATED: A task was edited.  - CLIENT_CHANGE_ACTION_TYPE_TASK_COMPLETED: A task was completed.  - CLIENT_CHANGE_ACTION_TYPE_TASK_DELETED: A task was deleted.  - CLIENT_CHANGE_ACTION_TYPE_NOTE_ADDED: A note was added.  - CLIENT_CHANGE_ACTION_TYPE_NOTE_UPDATED: A note was edited.  - CLIENT_CHANGE_ACTION_TYPE_NOTE_DELETED: A note was deleted.  - CLIENT_CHANGE_ACTION_TYPE_MANAGER_ASSIGNED: A manager was made responsible for the client.  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_ADDED: A way of contacting the client was added.  - CLIENT_CHANGE_ACTION_TYPE_CONTACT_REMOVED: A way of contacting the client was removed.  - CLIENT_CHANGE_ACTION_TYPE_DELETED: The client was deleted.  - CLIENT_CHANGE_ACTION_TYPE_FILE_UPLOADED: A file was uploaded.  - CLIENT_CHANGE_ACTION_TYPE_FILE_DOWNLOADED: A file was downloaded.
   * @param {number} [limit] Most entries to return. Fifty by default.
   * @param {number} [offset] How many entries to skip.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListClientChangeLogs(
    clientId: string,
    actionType?: ClientDataServiceListClientChangeLogsActionTypeEnum,
    limit?: number,
    offset?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListClientChangeLogs(clientId, actionType, limit, offset, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists clients with filters, sorting and paging.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {string} [responsibleManagerId]
   * @param {string} [leadSource]
   * @param {Array<string>} [statuses] Statuses to include.
   * @param {Array<string>} [leadSources] Lead sources to include.
   * @param {string} [dateFrom] Only clients created at or after this moment.
   * @param {string} [dateTo] Only clients created at or before this moment.
   * @param {string} [searchQuery] Full-text search over name, email address and phone number.
   * @param {string} [language] Language the client prefers to be addressed in.
   * @param {boolean} [hasDeal] True returns only clients that have a deal, false only those that have none. Left out, the filter is not applied.
   * @param {boolean} [isArchived] True returns only archived clients. False or left out returns only active ones.
   * @param {boolean} [hasResponsibleManager] True returns only clients that have a responsible manager, false only those without one. Left out, the filter is not applied. It backs the \&quot;my clients\&quot; and \&quot;unassigned\&quot; presets, and is ignored for callers who can see only their own clients anyway.
   * @param {string} [agentId] Agent who brought the client in.
   * @param {boolean} [hasAgent] True returns only clients brought in by an agent, false only those that came in directly. Left out, the filter is not applied.
   * @param {string} [agentDuplicateStatus] Whether an agent lead turned out to be someone already known: not_checked, unique, duplicate_pending, duplicate_confirmed or rejected. Whatever the filter says, the caller still only sees the clients their role allows.
   * @param {Array<string>} [tagKeys] Labels the client must carry. Several keys match a client carrying any one of them.
   * @param {Array<string>} [archiveReasonIds] Archive reasons to include. Several match a client archived for any one of them. Only meaningful together with the archived filter.
   * @param {Array<string>} [cityIds] Cities to include. A client counts as matching when its city comes from the dictionary; a manually typed city never matches.
   * @param {string} [countryId] Country of the client.
   * @param {Array<string>} [sourceKeys] Where the leads came from, at any depth of the source tree: a lead source alone, a site within it, or a campaign on that site. A client matches if it matches any of the keys.  A key is \&quot;&lt;lead_source_id&gt;\&quot;, \&quot;&lt;lead_source_id&gt;|&lt;landing_slug&gt;\&quot;, \&quot;&lt;lead_source_id&gt;|&lt;landing_slug&gt;|campaign:&lt;utm_campaign&gt;\&quot; or \&quot;&lt;lead_source_id&gt;|&lt;landing_slug&gt;|source:&lt;utm_source&gt;\&quot;; the site may be empty at the campaign level. Keys come from ListLeadSourceBreakdown.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListClientData(
    paginationPage?: string,
    paginationPerPage?: string,
    responsibleManagerId?: string,
    leadSource?: string,
    statuses?: Array<string>,
    leadSources?: Array<string>,
    dateFrom?: string,
    dateTo?: string,
    searchQuery?: string,
    language?: string,
    hasDeal?: boolean,
    isArchived?: boolean,
    hasResponsibleManager?: boolean,
    agentId?: string,
    hasAgent?: boolean,
    agentDuplicateStatus?: string,
    tagKeys?: Array<string>,
    archiveReasonIds?: Array<string>,
    cityIds?: Array<string>,
    countryId?: string,
    sourceKeys?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListClientData(
        paginationPage,
        paginationPerPage,
        responsibleManagerId,
        leadSource,
        statuses,
        leadSources,
        dateFrom,
        dateTo,
        searchQuery,
        language,
        hasDeal,
        isArchived,
        hasResponsibleManager,
        agentId,
        hasAgent,
        agentDuplicateStatus,
        tagKeys,
        archiveReasonIds,
        cityIds,
        countryId,
        sourceKeys,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the files attached to a client.
   * @param {string} clientId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListClientFiles(clientId: string, options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListClientFiles(clientId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists countries for administration.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListCountriesAdmin(options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListCountriesAdmin(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the sites and campaigns clients actually came through, under their lead source, as branches of the source filter.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListLeadSourceBreakdown(options?: RawAxiosRequestConfig) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListLeadSourceBreakdown(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists lead sources for administration, including inactive ones.
   * @param {boolean} [includeInactive] Include sources that are no longer offered. Useful when rendering clients attributed to one of them.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceListLeadSourcesAdmin(
    includeInactive?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceListLeadSourcesAdmin(includeInactive, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Records that someone downloaded a client\'s file, so the history shows who took what.
   * @param {string} clientId
   * @param {string} fileId
   * @param {ClientDataServiceLogClientFileDownloadBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceLogClientFileDownload(
    clientId: string,
    fileId: string,
    body: ClientDataServiceLogClientFileDownloadBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceLogClientFileDownload(clientId, fileId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Takes a label off a client and returns the labels it has afterwards.
   * @param {string} clientId
   * @param {string} tagKey
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceRemoveClientTag(
    clientId: string,
    tagKey: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceRemoveClientTag(clientId, tagKey, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Settles the claim that a client an agent submitted was already in the company\'s books: either hands the client over to that agent or leaves the card where it is. Either way the \"Duplicate\" label comes off and the card stops showing up in the duplicates widget.
   * @param {string} clientId
   * @param {ClientDataServiceResolveClientDuplicateBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceResolveClientDuplicate(
    clientId: string,
    body: ClientDataServiceResolveClientDuplicateBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceResolveClientDuplicate(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Resolves user identifiers into names, including people who have since left. Available to any authenticated caller, because manager names appear on every screen and not only in management reports.
   * @param {V1ResolveUsersRequest} body User identifiers to resolve into names. People who have left are included, so that historical references to them still read correctly.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceResolveUsers(
    body: V1ResolveUsersRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceResolveUsers(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Searches cities by name, for the city picker on a client card.
   * @param {string} [query] Text to match against city names. At least two characters.
   * @param {string} [countryId] Search only within this country.
   * @param {number} [limit] Most results to return. Ten by default, fifty at most.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceSearchCities(
    query?: string,
    countryId?: string,
    limit?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceSearchCities(query, countryId, limit, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Hands a manager\'s whole live portfolio over to another manager. Archived and deleted clients are left alone, and open deals follow their clients.
   * @param {V1TransferManagerClientsRequest} body Whose portfolio to hand over, and to whom. Archived and deleted clients stay with the manager who had them.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceTransferManagerClients(
    body: V1TransferManagerClientsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceTransferManagerClients(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes an archive reason.
   * @param {string} id
   * @param {ClientDataServiceUpdateArchiveReasonBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateArchiveReason(
    id: string,
    body: ClientDataServiceUpdateArchiveReasonBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateArchiveReason(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes a client. Fields left out keep their current values.
   * @param {string} clientId
   * @param {ClientDataServiceUpdateClientBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateClient(
    clientId: string,
    body: ClientDataServiceUpdateClientBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateClient(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Renames an attached file or changes its description. The file itself is untouched.
   * @param {string} clientId
   * @param {string} fileId
   * @param {ClientDataServiceUpdateClientFileBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateClientFile(
    clientId: string,
    fileId: string,
    body: ClientDataServiceUpdateClientFileBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateClientFile(clientId, fileId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes a country.
   * @param {string} id
   * @param {ClientDataServiceUpdateCountryBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateCountry(
    id: string,
    body: ClientDataServiceUpdateCountryBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateCountry(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes a lead source.
   * @param {string} id
   * @param {ClientDataServiceUpdateLeadSourceBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateLeadSource(
    id: string,
    body: ClientDataServiceUpdateLeadSourceBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateLeadSource(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Rewrites a note.
   * @param {string} clientId
   * @param {string} noteId
   * @param {ClientDataServiceUpdateManagerNoteBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataServiceApi
   */
  public clientDataServiceUpdateManagerNote(
    clientId: string,
    noteId: string,
    body: ClientDataServiceUpdateManagerNoteBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ClientDataServiceApiFp(this.configuration)
      .clientDataServiceUpdateManagerNote(clientId, noteId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * @export
 */
export const ClientDataServiceListClientChangeLogsActionTypeEnum = {
  Invalid: 'CLIENT_CHANGE_ACTION_TYPE_INVALID',
  Created: 'CLIENT_CHANGE_ACTION_TYPE_CREATED',
  Updated: 'CLIENT_CHANGE_ACTION_TYPE_UPDATED',
  StageChanged: 'CLIENT_CHANGE_ACTION_TYPE_STAGE_CHANGED',
  StatusChanged: 'CLIENT_CHANGE_ACTION_TYPE_STATUS_CHANGED',
  TaskCreated: 'CLIENT_CHANGE_ACTION_TYPE_TASK_CREATED',
  TaskUpdated: 'CLIENT_CHANGE_ACTION_TYPE_TASK_UPDATED',
  TaskCompleted: 'CLIENT_CHANGE_ACTION_TYPE_TASK_COMPLETED',
  TaskDeleted: 'CLIENT_CHANGE_ACTION_TYPE_TASK_DELETED',
  NoteAdded: 'CLIENT_CHANGE_ACTION_TYPE_NOTE_ADDED',
  NoteUpdated: 'CLIENT_CHANGE_ACTION_TYPE_NOTE_UPDATED',
  NoteDeleted: 'CLIENT_CHANGE_ACTION_TYPE_NOTE_DELETED',
  ManagerAssigned: 'CLIENT_CHANGE_ACTION_TYPE_MANAGER_ASSIGNED',
  ContactAdded: 'CLIENT_CHANGE_ACTION_TYPE_CONTACT_ADDED',
  ContactRemoved: 'CLIENT_CHANGE_ACTION_TYPE_CONTACT_REMOVED',
  Deleted: 'CLIENT_CHANGE_ACTION_TYPE_DELETED',
  FileUploaded: 'CLIENT_CHANGE_ACTION_TYPE_FILE_UPLOADED',
  FileDownloaded: 'CLIENT_CHANGE_ACTION_TYPE_FILE_DOWNLOADED',
} as const
export type ClientDataServiceListClientChangeLogsActionTypeEnum =
  (typeof ClientDataServiceListClientChangeLogsActionTypeEnum)[keyof typeof ClientDataServiceListClientChangeLogsActionTypeEnum]
